import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ShowEcorregimesGuardService {

    constructor(public router: Router) {}

    canActivate(): boolean {

        if (!environment.features.showEcorregimenes) {
            this.router.navigate(['login']);
            return false;
        }

        return true;
    }
}
